import { call, put, select } from 'redux-saga/effects';
import { topbarVisibilityChanged, topbarVisibilityToggled } from 'features/topbar/topbarSlice';
import { selectAllowChangeLogo } from 'features/branding/brandingSlice';
import { eventBus } from 'utils/eventBus';

export function* onControlTopbarCommandSaga(show?: boolean) {
  const allowChangeLogo: boolean = yield select(selectAllowChangeLogo);

  if (!allowChangeLogo) {
    yield call(
      eventBus.forbiddenActionError,
      'Forbidden action. This participant is not allowed to control topbar',
      'update-topbar'
    );
    return;
  }

  if (typeof show === 'boolean') {
    yield put(topbarVisibilityChanged(show));
  } else {
    yield put(topbarVisibilityToggled());
  }
}
